import React from 'react';
import PropTypes from 'prop-types';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import { CartBackToHomeLinkBuilder } from 'ggApp/shared/containers/cartBackToHomeLinkBuilder';

import { Container, Image, Subheadline, Button, Link } from './styled';
import img from './images/emptyBox.svg';

const EmptyCart = ({ withBackToHomeLink }) => (
    <Container>
        <Image src={img} alt="empty cart" />
        <Subheadline>
            <Translator tk="EMPTY_CART" />
        </Subheadline>
        {withBackToHomeLink && (
            <CartBackToHomeLinkBuilder
                render={({ backToHomeLink }) => (
                    <Link to={backToHomeLink} external>
                        <Button>
                            <Translator tk="CART_BACK_TO_HOME_TEXT" />
                        </Button>
                    </Link>
                )}
            />
        )}
    </Container>
);

EmptyCart.propTypes = {
    withBackToHomeLink: PropTypes.bool,
};

EmptyCart.defaultProps = {
    withBackToHomeLink: true,
};

export default EmptyCart;
